// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {WBSearchableSelect} from '../elements/WBSearchableSelect';

export const AnnotationWrapper = styled.div`
  & + & {
    margin-top: 12px;
  }
`;

export const HeaderP = styled.p`
  && {
    margin-top: 16px;


  @media only screen and (max-width: 1199px) {
    margin-left: 16px;
  }
`;

export const StyledSearchableSelect = styled(WBSearchableSelect)`
  width: 100%;
`;
